var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.showHead
      ? _c(
          "div",
          { class: _vm.headClasses, style: _vm.headerStyle },
          [
            _vm._t("title", function() {
              return [
                _vm.title
                  ? _c("p", [_c("span", [_vm._v(_vm._s(_vm.title))])])
                  : _vm._e()
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm.showExtra
      ? _c("div", { class: _vm.extraClasses }, [_vm._t("extra")], 2)
      : _vm._e(),
    _c(
      "div",
      { class: _vm.bodyClasses, style: _vm.bodyStyles },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9db7f6f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9db7f6f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Card/Card.vue
// module id = AT9/
// module chunks = 0